// Real customer testimonials carried over from the legacy store site
// (store.velanapps.com) — quotes and names preserved verbatim from the
// original carousel markup. Photos downloaded to public/images/store/testimonials.

export const storeTestimonials = [
  {
    id: "store.01",
    quote: "Very attentive and talented designer. Made an extra effort to get it perfect even after the design was awarded. Would hire again",
    name: "ANDRE QUEIROZ DE ANDRADE",
    company: "NVICEN HEALTH",
    image: "/images/store/testimonials/andre-queiroz-de-andrade.webp",
  },
  {
    id: "store.02",
    quote: "Great idea, much better than going with a single designer from the start and got to see a ton of ideas and variety to the design. Thanks!",
    name: "ADAM WELWOOD",
    company: "TOWN SQUARE",
    image: "/images/store/testimonials/adam-welwood.webp",
  },
  {
    id: "store.03",
    quote: "Nice job to you and the team. Thanks to all of you for the great support. The site looks really good and has the right messaging.",
    name: "MICHAEL",
    company: "FUTURE GUIDES LLC",
    image: "/images/store/testimonials/michael.webp",
  },
  {
    id: "store.04",
    quote: "Velan did an incredible job with my website. They streamline the entire process and are prompt to make changes as they arise. I will continue to work with them on future websites and highly recommend their services to anyone looking for a great website!",
    name: "CHRISTIAN",
    company: "LINEYOURSSELF",
    image: "/images/store/testimonials/christian.webp",
  },
  {
    id: "store.05",
    quote: "Really happy with the excellent work done for my Magento site. I will look forward to working with Velan on many projects as we go forward.Thank you for your service.",
    name: "JAMES",
    company: "READY TO DEFEND",
    image: "/images/store/testimonials/james.webp",
  },
  {
    id: "store.06",
    quote: "Great designer. A creative talent who is very easy to work with and really captured the essence of what I was trying to achieve.",
    name: "TAMIA PERRY",
    company: "URBAN ECOSPACES",
    image: "/images/store/testimonials/tamia-perry.webp",
  },
];
